import { SVGProps } from 'react';

function Dots(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={25}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.986 23.133c1.45 0 2.625-1.17 2.625-2.611a2.618 2.618 0 0 0-2.625-2.612 2.618 2.618 0 0 0-2.625 2.612 2.618 2.618 0 0 0 2.625 2.611ZM12.986 5.972c1.45 0 2.625-1.17 2.625-2.612A2.618 2.618 0 0 0 12.986.75 2.618 2.618 0 0 0 10.36 3.36a2.618 2.618 0 0 0 2.625 2.612ZM12.986 14.553c1.45 0 2.625-1.17 2.625-2.612a2.618 2.618 0 0 0-2.625-2.611 2.618 2.618 0 0 0-2.625 2.611 2.618 2.618 0 0 0 2.625 2.611Z"
        fill="#BABEC9"
      />
    </svg>
  );
}

Dots.defaultProps = {
  role: 'graphics-document',
};

export default Dots;
